import React, { useEffect } from "react";
import useAuth from ".";
import API_ENDPOINTS from "../apis/endpoints";

export default function AuthProviderWrapper({ children }) {
    const auth = useAuth();

    const RefreshAccesToken = async () => {
        try {
            if (auth.refreshToken) {
                let formData = new FormData();
                formData.append("refresh_token", auth.refreshToken);
                const storedDeviceId = localStorage.getItem("device-id");

                const response = await fetch(
                    `${API_ENDPOINTS.EXCHANGE_TOKEN}`,
                    {
                        method: "POST",
                        headers: {
                            "ngrok-skip-browser-warning": "true",
                            "x-cc-device-id": storedDeviceId,
                        },
                        body: formData,
                    }
                );

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const data = await response.json();

                auth.setAccessToken(data?.data?.access_token ?? null);

                const userDetails = data?.data?.user ?? null;

                auth.setUser(userDetails);

                let expiresIn =
                    parseInt(data?.data?.expires ?? "0") - Date.now();
                expiresIn -= 1000 * 60;
                if (expiresIn <= 60000) {
                    expiresIn = 1000 * 60 * 9;
                }
                setTimeout(() => {
                    RefreshAccesToken();
                }, expiresIn);
            }
        } catch (error) {
            console.log(error);
            auth.logout();
        }
    };

    useEffect(() => {
        RefreshAccesToken();
    }, []);

    if (auth.isAuthenticated && (!auth.user || !auth.accessToken)) {
        return null;
    }

    return children;
}
